<template>
  <svg width="21" height="28" viewBox="0 0 21 28" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 7.93A7 7 0 0 1 11.19 0C7.7.63 5 5.28 5 10.93c0 1.84.29 3.57.8 5.1-1.64-1.19-2.76-3.4-2.8-5.95a10.5 10.5 0 1 0 12-2.14ZM7.5 25c.87 0 1.7-.16 2.47-.45 1.85-.87 2.78-2.86 2.78-5.32 0-1.65-.67-3.14-1.76-4.23a5.9 5.9 0 0 1 3.87 3.53 8.25 8.25 0 0 0-2.04-7.17A7.5 7.5 0 0 1 10.5 26h-.04a7.46 7.46 0 0 1-3.79-1.05c.28.03.55.05.83.05Z"
      fill="currentColor"
    />
  </svg>
</template>
